<template>
  <div class="layout--main">
    <TheStepsNavbar />
    <router-view></router-view>
  </div>
</template>

<script>
import TheStepsNavbar from "../components/TheStepsNavbar";

import { mapState } from "vuex";

export default {
  created() {
    window.scroll(0, 0);
    this.updatePrimaryColor();
    this.$store.dispatch("step/clearStepsState");
  },

  computed: { ...mapState("company", ["company"]) },
  components: { TheStepsNavbar },

  methods: {
    updatePrimaryColor() {
      if (
        this.company &&
        this.company.hasOwnProperty("base_hexcolor") &&
        this.company.base_hexcolor !== ""
      )
        this.$vs.theme({ primary: this.company.base_hexcolor });
    }
  }
};
</script>
